import Account from 'components/Controller/Account'
import { Navigate } from 'react-router-dom'
import Main from './Main'
const DashboardModule = [
	{
		path: 'account',
		element: <Navigate to='account/dashboard' />,
	},
	{
		path: 'account/dashboard',
		element: (
			<Account>
				<Main />
			</Account>
		),
	},
]
export default DashboardModule
